import { Link } from "react-router-dom";
import { BRAND } from "@/data/products";

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="relative bg-ink text-cream overflow-hidden"
    >
      <div className="absolute inset-0 pattern-bg opacity-70 pointer-events-none" />
      <div className="relative px-6 sm:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src="/logo-goodspoon.png"
              alt="The Good Spoon"
              className="h-20 w-auto"
            />
            <p className="eyebrow mt-6">Naturally Better Spices</p>
            <p className="font-primary text-cream/60 mt-4 max-w-sm leading-relaxed">
              A modern, quality-focused spice brand — carefully sourced, cleanly
              processed, and sealed for freshness.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="font-primary text-xs font-semibold uppercase tracking-[0.2em] text-coral">
              Explore
            </p>
            <div className="mt-6 flex flex-col gap-3 font-primary">
              <Link to="/" className="text-cream/70 hover:text-cream transition-colors">Home</Link>
              <Link to="/story" className="text-cream/70 hover:text-cream transition-colors">Story</Link>
              <Link to="/products" className="text-cream/70 hover:text-cream transition-colors">Products</Link>
              <Link to="/contact" className="text-cream/70 hover:text-cream transition-colors">Contact</Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-primary text-xs font-semibold uppercase tracking-[0.2em] text-coral">
              Reach Us
            </p>
            <div className="mt-6 flex flex-col gap-3 font-primary text-cream/70">
              <a href={`mailto:${BRAND.email}`} className="hover:text-cream transition-colors">{BRAND.email}</a>
              <a href={`https://wa.me/${(BRAND.whatsapp || "").replace(/[^0-9]/g, "")}`} target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">{BRAND.phone}</a>
              <span>{BRAND.city}</span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-primary text-xs text-cream/40 uppercase tracking-[0.15em]">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="font-primary text-xs text-cream/40 uppercase tracking-[0.15em]">
            Crafted in {BRAND.city}
          </p>
        </div>
      </div>
    </footer>
  );
};
